import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { Button, useDisclosure } from "@chakra-ui/react";
import { FaCog } from "@onemind-services-llc/react-icons-ng/fa";
import VisibilityModal from "./visibilityModal";
/** This component provides way to configure table columns which can be used by tanstack-table v8: https://tanstack.com/table/v8
 * - For UI of this component to work properly create Button component variant named `table-config-btn` in Chakra-UI theme
 */
export const TableConfig = (props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    return (_jsxs(Fragment, { children: [_jsx(VisibilityModal, Object.assign({ isOpen: isOpen, onClose: onClose }, props)), _jsx(Button, { leftIcon: _jsx(FaCog, {}), variant: "outline", onClick: onOpen, "data-cy": "configure-table", children: "Configure Table" })] }));
};
//# sourceMappingURL=tableConfig.js.map